import config from '../config';

export default class ClipApi {

    static findByOrganizationId = async (organizationId, keyword, live_format, live_content, start_date, end_date, page = 1, size = 20) => {
        let url = `${config.url.api}/organizations/${organizationId}/clips`;
        const params = new URLSearchParams();

        if (keyword) {
            params.append('keyword', keyword);
        }
        if (live_format) {
            params.append('live_format', live_format);
        }
        if (live_content) {
            params.append('live_content', live_content);
        }
        if (start_date) {
            params.append('start_date', start_date);
        }
        if (end_date) {
            params.append('end_date', end_date);
        }
        params.append('page', page);
        params.append('size', size);
        
        const queryString = params.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }

        const res = await fetch(url);
        const json = await res.json();
        if (!res.ok) {
            throw json;
        }
        return json;
    }
}